export default __webpack_public_path__ + "static/media/06_photo.722d3623.jpg";